import { useState, type FormEvent } from "react";

const contactEmail = "contact@heiliaotrack.example";
const channelsFoot = [
  { label: "娱乐圈事件", href: "#latest" },
  { label: "主播网红动态", href: "#latest" },
  { label: "商业科技争议", href: "#latest" },
  { label: "社会百态见闻", href: "#latest" },
];
const guideFoot = [
  { label: "头条聚焦", href: "#top" },
  { label: "最新事件速递", href: "#latest" },
  { label: "实时热榜追踪", href: "#rank" },
  { label: "时间线复盘", href: "#timeline" },
  { label: "常见问答", href: "#faq" },
];

export default function FooterSection() {
  const [subStatus, setSubStatus] = useState<"idle" | "ok" | "err">("idle");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const hp = String(data.get("website_alt") || "").trim();
    setMsg("");
    if (hp) {
      setSubStatus("ok");
      form.reset();
      return;
    }
    const payload = new URLSearchParams();
    data.forEach((v, k) => {
      if (k === "website_alt") return;
      payload.append(k, String(v));
    });
    try {
      const res = await fetch(
        "https://readdy.ai/api/form/daglfq9tto0ceqqnhuo0",
        { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: payload.toString() }
      );
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      if (res.ok && code === "OK") {
        setSubStatus("ok");
        form.reset();
      } else {
        setSubStatus("err");
        setMsg(
          typeof serverMsg === "string" && serverMsg
            ? serverMsg
            : "提交未成功，请稍后再试或核对填写内容。"
        );
      }
    } catch {
      setSubStatus("err");
      setMsg("网络异常，提交失败，请稍后再试。");
    }
  };

  return (
    <section id="about" className="scroll-mt-20">
      {/* contact / subscribe */}
      <div className="bg-foreground-950">
        <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-14 md:px-6 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">
              跟着「最近黑料」，不漏任何新进展
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-200 md:text-base">
              从发酵、回应到反转，我们持续跟进近期事件的最新走向，把时间线和关键节点整理清楚。留下联系方式，事件有重大更新时会第一时间通知你。
            </p>
            <div className="mt-7 flex flex-col gap-3 text-sm text-foreground-100 sm:flex-row sm:items-center sm:gap-6">
              <span className="inline-flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                  <i className="ri-verified-badge-line" />
                </span>
                事实与猜测分开标注
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-refund-line" />
                </span>
                反转节点即时补充
              </span>
            </div>
          </div>

          <form
            id="progress-subscribe"
            data-readdy-form
            onSubmit={handleSubmit}
            className="rounded-xl border border-background-200/70 bg-background-100 p-6 md:p-7"
          >
            <p className="font-heading text-lg font-bold text-foreground-950">
              订阅最新进展
            </p>
            <p className="mt-1 text-sm text-foreground-500">
              填写邮箱，我们会在有重大更新或反转时通知你。
            </p>
            <div className="mt-5 space-y-3">
              <input
                type="email"
                name="email"
                required
                placeholder="你的邮箱地址"
                className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
              <select
                name="interest"
                className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none focus:border-primary-400"
                defaultValue="综合"
              >
                <option>综合关注</option>
                <option>娱乐圈事件</option>
                <option>主播网红动态</option>
                <option>商业科技争议</option>
                <option>社会百态见闻</option>
              </select>
              <textarea
                name="message"
                maxLength={500}
                rows={3}
                placeholder="想让我们持续跟进的事件，或给编辑部的反馈（选填，500 字以内）"
                className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400"
              />
              {/* honeypot */}
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="hp-trap" />
              <button
                type="submit"
                className="inline-flex w-full whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-line" />
                提交订阅
              </button>
              {subStatus === "ok" && (
                <p className="rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-800">
                  已收到，感谢你的关注！有最新进展我们会第一时间通知你。
                </p>
              )}
              {subStatus === "err" && (
                <p className="rounded-md bg-primary-100 px-3 py-2 text-sm text-primary-800">
                  {msg || "提交未成功，请稍后再试。"}
                </p>
              )}
            </div>
          </form>
        </div>
      </div>

      {/* footer */}
      <footer className="bg-background-300">
        <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2.5">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-focus-3-line" />
                </span>
                <span className="font-heading text-lg font-black text-foreground-950">
                  最近黑料
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                一个专注近期事件与热点的信息追踪站。汇总发酵、回应与反转的时间线，帮你理清新进展，不遗漏任何可能。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">
                内容栏目
              </h3>
              <ul className="mt-3 space-y-2.5">
                {channelsFoot.map((c) => (
                  <li key={c.label}>
                    <a href={c.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {c.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">
                快速导航
              </h3>
              <ul className="mt-3 space-y-2.5">
                {guideFoot.map((c) => (
                  <li key={c.label}>
                    <a href={c.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {c.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">
                联系编辑部
              </h3>
              <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-700" />
                  <a href={`mailto:${contactEmail}`} className="hover:text-primary-700">
                    {contactEmail}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-700" />
                  每日 09:00 - 23:00 持续跟进
                </li>
              </ul>
              <p className="mt-4 text-xs leading-relaxed text-foreground-500">
                本站内容仅作信息汇总参考，涉及事实以官方声明与公开资料为准。
              </p>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
            <p className="text-xs text-foreground-500">
              © 2026 最近黑料 · 仅作信息整理与阅读参考，不做事实定性判断。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#top" className="inline-flex items-center gap-1 hover:text-primary-700">
                返回顶部 <i className="ri-arrow-up-line" />
              </a>
              <a href="#faq" className="hover:text-primary-700">
                内容说明
              </a>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}